const header = "mb-4 sm:mb-6 flex items-start justify-between gap-3";

const headerMobileHidden = "mb-4 sm:mb-6 hidden sm:flex items-start justify-between gap-3";

const left = "flex min-w-0 items-center gap-2";

const backBtn = "rounded-md p-1.5 -ml-1.5 text-muted-foreground hover:bg-accent hover:text-foreground transition-colors shrink-0";

const icon = "h-5 w-5 shrink-0 text-primary";

const iconMobileHidden = "h-5 w-5 shrink-0 text-primary hidden sm:block";

const textGroup = "min-w-0";

const textGroupMobileHidden = "hidden sm:block min-w-0";

const title = "truncate text-lg sm:text-xl font-bold tracking-tight text-foreground";

const description = "mt-0.5 text-sm text-muted-foreground";

const action = "flex shrink-0 items-center gap-2";

export { header, headerMobileHidden, left, backBtn, icon, iconMobileHidden, textGroup, textGroupMobileHidden, title, description, action };
